import React, { useState, useEffect } from "react";
import {
  ChartComponent,
  SeriesCollectionDirective,
  SeriesDirective,
  Inject,
  ColumnSeries,
  Category,
  DataLabel,
  Tooltip,
  Legend,
} from "@syncfusion/ej2-react-charts";

const TopUsersChart = ({ selectedSkill, chartsData }) => {
  const [data, setData] = useState([]);
  const [selectedSkillName, setSelectedSkillName] = useState("");

  useEffect(() => {
    if (chartsData?.top_users_for_skill?.length > 0) {
      const sortedData = chartsData.top_users_for_skill
        .map((item) => ({
          ...item,
          userEmail: item.userEmail || "Unknown User",
        }))
        .sort((a, b) => b.count - a.count)
        .slice(0, 10);
      setData(sortedData);
    } else {
      setData([]);
    }

    // setSelectedSkillName(selectedSkill || "");
  }, [chartsData, selectedSkill]);

  const onAxisLabelRender = (args) => {
    if (args.axis.name === "primaryYAxis") {
      const numericValue = Number(args.text);
      if (!Number.isInteger(numericValue)) args.cancel = true;
    }
  };

  return (
    <div className="chart-display-width" style={{ overflowX: "auto" }}>
      <h3 className="chart-title">
        Top 10 Users by Total Chats
        {/* {selectedSkillName ? ` – Skill: ${selectedSkillName}` : ""} */}
      </h3>

      {data.length === 0 ? (
        <div className="container-no-records">No Records Found</div>
      ) : (
        <ChartComponent
          id="charts"
          primaryXAxis={{
            valueType: "Category",
            title: "Users",
            labelIntersectAction: "Rotate45",
            visible: false,
          }}
          primaryYAxis={{
            title: "Total Chats",
            minimum: 0,
            labelFormat: "{value}",
            rangePadding: "None",
          }}
          tooltip={{ enable: true }}
          legendSettings={{ visible: false }}
          axisLabelRender={onAxisLabelRender}
        >
          <Inject
            services={[ColumnSeries, DataLabel, Category, Tooltip, Legend]}
          />
          <SeriesCollectionDirective>
            <SeriesDirective
              type="Column"
              dataSource={data}
              xName="userEmail"
              yName="count"
              name="Total Chats"
              columnSpacing={0.3} // ✅ adds space between bars
              columnWidth={0.4} // ✅ narrower bars
              marker={{
                dataLabel: {
                  visible: true,
                  position: "Top",
                  font: {
                    fontWeight: "600",
                    color: "#000000ff", // ✅ White text for dark blue bar
                    size: "13px", // Optional: Increase size
                  },
                },
              }}
              fill="#4F46E5"
            />
          </SeriesCollectionDirective>
        </ChartComponent>
      )}
    </div>
  );
};

export default TopUsersChart;
